export const REVENU_MAX = 999999;
export const REVENU_MIN = 15000;
export const PDF_MAX_SIZE = 76;

export const MAX_INPUT_TAXES_SCOLAIRES = 2000;
export const MAX_INPUT_TAXES_MUNICIPALES = 10000;
export const MAX_INPUT_COUT_ENERGIE = 500;
export const MAX_INPUT_FRAIS_COPROPRIETE = 1000;

export const REGEX_EMAIL = /^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^-]+(?:\.[a-zA-Z0-9_!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/;

export const maskCurrencyFr = { prefix: '', thousands: ' ', precision: 0 };

export const maskCurrencyEn = { prefix: '', thousands: ',', precision: 0 };

export const unMaskCurrencyFr = (value: string): number => {
  return Number(value.replace(' ', ''));
};

export const unMaskCurrencyEn = (value: string): number => {
  return Number(value.replace(',', ' '));
};

export const getCurrencyMask = (langue: string): any[] => {
  switch (langue) {
    case 'fr':
      return [maskCurrencyFr, unMaskCurrencyFr];
    case 'en':
      return [maskCurrencyEn, unMaskCurrencyEn];
  }
};
